import { host } from '../hooks/serviceGetways';
const Singleton = (function () {
    let instance;

    function createInstance() {
        const io = require('socket.io-client')
        const socket = io.connect(host.replace('/api', ''), {
            auth: {
                token: "abcdaa"
            }, transport: ['websocket']
        })

        socket.on('connect', () => {
            console.log('[SocketControl] Socket connected! ID:', socket.id);
        });

        socket.on('connect_error', (err) => {
            console.log('[SocketControl] Socket connection error:', err.message);
        });

        socket.on('disconnect', (reason) => {
            console.log('[SocketControl] Socket disconnected:', reason);
        });

        return socket;
    }

    return {
        getInstance: function () {
            if (!instance) {
                instance = createInstance();
            }
            return instance;
        }
    };
})();

export default Singleton;